import React from 'react';
import { CompassIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-dark-border bg-dark px-5 py-12 text-center" data-id="element-100">
      <div className="mx-auto max-w-6xl" data-id="element-101">
        <div className="flex items-center justify-center gap-3 text-stone-light" data-id="element-102">
          <CompassIcon className="h-5 w-5 text-gold-light" data-id="element-103" />
          <span className="font-heading text-2xl font-semibold" data-id="element-104">
            Los Secretos de la Civilización Maya
          </span>
        </div>
        <p className="mt-4 text-sm text-stone" data-id="element-105">
          Una colección documental para explorar el legado de Mesoamérica.
        </p>
        <p className="mt-8 text-xs text-stone" data-id="element-106">
          © 2026 Los Secretos de la Civilización Maya. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}